import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to top on route change
 * This should be placed inside the Router component
 */
const ScrollToTop: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Get user preference for scroll behavior
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    
    // Use smooth scrolling unless user prefers reduced motion
    const scrollBehavior: ScrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';
    
    // Scroll to top when route changes
    window.scrollTo({ top: 0, behavior: scrollBehavior });
    
    // Alternative: Use scrollIntoView for better browser compatibility
    // document.body.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
  }, [pathname]);

  return null; // This component doesn't render anything
};

export default ScrollToTop;
